import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["autocomplete", "initialValues"]

import { useForm } from "vee-validate"

  interface Props {
    validationSchema: object
    autocomplete?: string
    initialValues?: any
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'formTemplate',
  props: {
    validationSchema: null,
    autocomplete: null,
    initialValues: null
  },
  emits: ["valid"],
  setup(__props: any, { emit }) {

const props = __props as {
    validationSchema: object
    autocomplete?: string
    initialValues?: any
  }

  

  const { handleSubmit, resetForm } = useForm({
    validationSchema: props.validationSchema,
  })
  
  /**
   * handle submit function
   */
  const onSubmit = handleSubmit((values) => {
    emit("valid", values)
  })
  const onReset = () => {
    const initials = JSON.parse(JSON.stringify(props.initialValues))
    if (initials) resetForm({ values: initials })
    else resetForm()
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    autocomplete: props.autocomplete || 'on',
    initialValues: props.initialValues,
    onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
    onReset: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onReset()), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})